import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { updateOrderParam } from "features/hublink/core/tei-hub-link.param";
import {
  GetTeiHubLinkAcceptOrderResponse,
  GetTeiHubLinkAcceptOrderRepository,
} from "features/hublink/data/tei-hub-link.repository";

export enum TeiHubLinkAcceptOrder {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: TeiHubLinkAcceptOrder;
  message: string;
}

const initialState: InitialState = {
  status: TeiHubLinkAcceptOrder.initial,
  message: "",
};

export const teiHubLinkAcceptOrder = createAsyncThunk(
  "teiHubLinkAcceptOrder",
  async (param: updateOrderParam, { rejectWithValue }) => {
    try {
      const response: GetTeiHubLinkAcceptOrderResponse =
        await GetTeiHubLinkAcceptOrderRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const teiHubLinkAcceptOrderSlice = createSlice({
  name: "teiHubLinkAcceptOrder",
  initialState,
  reducers: {
    resetTeiHubLinkAcceptOrder: (state) => {
      state.status = TeiHubLinkAcceptOrder.initial;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(teiHubLinkAcceptOrder.pending, (state) => {
        state.status = TeiHubLinkAcceptOrder.inProgress;
      })
      .addCase(teiHubLinkAcceptOrder.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = TeiHubLinkAcceptOrder.success;
          state.message = message;
        }
      })
      .addCase(teiHubLinkAcceptOrder.rejected, (state, action) => {
        state.status = TeiHubLinkAcceptOrder.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectTeiHubLinkAcceptOrder = (state: RootState) =>
  state.teiHubLinkAcceptOrder;

export const { resetTeiHubLinkAcceptOrder } =
  teiHubLinkAcceptOrderSlice.actions;
export default teiHubLinkAcceptOrderSlice.reducer;
